export default [
    {
        path: '/static/order/add',
        name: 'order-add',
        component: () => import('views/modules/order/add'),
        meta: {
            parent: '/order/list',
            title: '下单',
        },
    },
    {
        path: '/static/order/detail',
        name: 'order-detail',
        component: () => import('views/modules/order/detail'),
        meta: {
            parent: '/order/list',
            title: '详情',
        },
    },
    /* {
        path: '/static/setting/staticize',
        name: 'staticize',
        component: () => import('views/modules/setting/staticize'),
        meta: {
            title: '静态化管理',
        },
    }, */
    {
        path: '/static/forward/sitelist',
        name: 'forward-sitelist',
        component: () => import('views/modules/forward/sitelist'),
        meta: {
            parent: '/order/list',
            title: '目标网站',
        },
    },
    {
        path: '/static/forward/log',
        name: 'forward-log',
        component: () => import('views/modules/forward/log'),
        meta: {
            parent: '/order/list',
            title: '转发日志',
        },
    },
    {
        path: '/static/forward/setlist',
        name: 'forward-setlist',
        component: () => import('views/modules/forward/setlist'),
        meta: {
            parent: '/order/list',
            title: '转发设置',
        },
    },
    {
        path: '/static/translate',
        name: 'translate-detail',
        component: () => import('views/modules/setting/translate'),
        meta: {
            parent: '/setting',
            title: '翻译设置',
        },
    },
];
